/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import Typography from "@mui/material/Typography";
import { Link, LinkProps } from "react-router";
import React from "react";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { footerLinkStyle } from "@/src/components/Footer/footerLinkStyle.ts";

export type FooterLinkProps = {
  label: string;
} & Pick<LinkProps, "to">;

export default function FooterLink({ to, label }: FooterLinkProps) {
  return (
    <Typography
      component={Link}
      to={to}
      sx={mergeSx(
        {
          color: "inherit",
        },
        footerLinkStyle.link,
      )}
    >
      {label}
    </Typography>
  );
}
